/** 镜像 containerDeployConfig 相关表单 hidden 字段（L1 / L2 共用） */
export const IMAGE_CONTAINER_DEPLOY_MOUNT_PATH_FIELD = '_imageContainerDeployMountPath';

/** 镜像启动命令预置（hidden） */
export const IMAGE_CONTAINER_DEPLOY_STARTUP_FIELD = '_imageContainerDeployStartup';

/** 镜像 instanceScheduling，供节点资源约束 */
export const IMAGE_CONTAINER_DEPLOY_INSTANCE_SCHEDULING_FIELD = '_imageContainerDeployInstanceScheduling';
